export default {
  title () {
    return `Email link (${this.options.appState.get('factorProfile').email})`;
  }
};



// WEBPACK FOOTER //
// ./src/v2/view-builder/views/shared/email.js